import { render, staticRenderFns } from "./AddAccountModal.vue?vue&type=template&id=5651449a&scoped=true"
import script from "./AddAccountModal.vue?vue&type=script&lang=ts"
export * from "./AddAccountModal.vue?vue&type=script&lang=ts"
import style0 from "./AddAccountModal.vue?vue&type=style&index=0&id=5651449a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5651449a",
  null
  
)

export default component.exports